export const environment = {
  production: true,
  mock: {
    db: {},
    methods: {}
  }
};
